import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';

import { CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH } from '../../constants/onboarding-state/onboarding-constants.ts';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql.ts';

export const preloadRovoAnnouncementOnboardingState = () => {
	const preloadedSessionContext = getPreloaderFnContext();
	const { userId, accessStatus } = preloadedSessionContext;

	const isLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;

	const tasks: Promise<any>[] = [];

	if (isLicensed && userId) {
		tasks.push(
			query({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: getOnboardingStateGQL,
				variables: {
					key: [...Object.values(CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH)],
				},
			}),
		);
	}

	return waitForAllReturnWhenError(tasks);
};
